module.exports = __webpack_public_path__ + "static/img/geruchsneutral.74c37098.svg";